<template>
  <div class="accumulation">
    <div class="enter">
      <div class="qw-container">
        <h3>{{ c.qw0 }}</h3>
        <div class="grid"
          @click="cardsClickHandler($event)">
          <div class="category">
            <span>{{ c.cardsCategory[0] }}</span>
            <button class="info"
              @click="openPopup($parent.dimensions[0],'index', $parent.dimensions[0].dataset)">?</button>
          </div>
          <div class="category">
            <span>{{ c.cardsCategory[1] }}</span>
            <button class="info"
              @click="openPopup($parent.dimensions[1],'index', $parent.dimensions[1].dataset)">?</button>
          </div>
          <div class="category">
            <span>{{ c.cardsCategory[2] }}</span>
            <button class="info"
              @click="openPopup($parent.dimensions[2],'index', $parent.dimensions[2].dataset)">?</button>
          </div>
          <div class="card" 
            v-for="(card, id) in cards" 
            :data-id="id" 
            :key="id"
            :class="selectedCardId === id ? 'selected' : ''">
            <img :src="card.icon" alt="">
            <div class="container">
              <p>{{ card.name }}</p>
              <button 
                @click="openPopup($parent.dimensions[id < 3? id: (id < 6? id-3: id-6)], 'unit', cards[id])">
                {{ formatNumber(card.startPrice>=1000000? 
                  ((card.startPrice/1000000).toFixed(4).toString().slice(0, -3)):
                  card.startPrice.toString(),true
                ) + (card.startPrice>=1000000? ' млн ₽': ' ₽')}} </button>
            </div>
          </div>
        </div>
      </div>
      <div class="qw-container">
        <h3>{{ c.qw1 }}</h3>
        <div class="input-container">
          <span class="input-label">
            <input class="input-val startValInput"
            :max="money.max" :step="money.step" :min="money.min" 
            v-model="startValInput" type="text"
            @focus="focusHandler($event, 'startVal')"
            @blur="blurHandler($event, 'startVal')"
            @change="handleInputChange('startVal', 'startValInput', money)"
            @input="handleInput($event, 'startVal', 'startValInput', money)">
            <div class="input-buffer startValHide">
              {{ startValInput.toLocaleString('ru') }}
            </div>
            <span class="currency startValCy">₽</span>
          </span>
          <RangeSlider class="slider" v-model="startVal"
            :min="money.min" :max="money.max" :step="money.step"
            @change="handleInputChange('startVal', 'startValInput', money, true), 
              onSliderFocus('startVal')"/>
          <div class="sub-container">
            <span class="sub-span">{{ formatNumber(money.min.toString()) }} ₽</span>
            <span class="sub-span">{{ formatNumber(money.max.toString()) }} ₽</span>
          </div>
        </div>
      </div>
      <div class="qw-container">
        <h3>{{ c.qw2 }}</h3>
        <div class="input-container">
          <span class="input-label">
            <input class="input-val additionValInput"
            :max="moneyAdd.max" :step="moneyAdd.step" :min="moneyAdd.min" 
            v-model="additionValInput" type="text" :disabled="checked"
            @focus="focusHandler($event, 'additionVal')"
            @blur="blurHandler($event, 'additionVal')"
            @change="handleInputChange('additionVal', 'additionValInput', moneyAdd)"
            @input="handleInput($event, 'additionVal', 'additionValInput', moneyAdd)">
            <div class="input-buffer additionValHide">
              {{ additionValInput.toLocaleString('ru') }}
            </div>
            <span class="currency additionValCy" :class="checked? 'disabled':''">₽</span>
          </span>
          <RangeSlider class="slider" v-model="additionVal"
            :min="moneyAdd.min" :max="moneyAdd.max" :step="moneyAdd.step"
            :disabled="checked"
            @change="onSliderFocus('additionVal', $event)"/>
          <div class="sub-container">
            <span class="sub-span">{{ formatNumber(moneyAdd.min.toString()) }} ₽</span>
            <span class="sub-span">{{ formatNumber(moneyAdd.max.toString()) }} ₽</span>
          </div>
        </div>
        <div class="options"
          @click="optionsClickHandler($event)">
          <div class="option" v-for="(el, id) in c.options" :key="id">
            <input type="checkbox" :id="'cb'+id" :data-val='+el.val'>
            <label :for="'cb'+id">{{el.text}} +{{ (+el.val).toLocaleString('ru') }}</label>
          </div>
        </div>
      </div>
      <a class="btn gradient-btn-accum" href="#outputAccum">{{ c.btn }}</a>
    </div>

    <div class="output">
      <header id="outputAccum">
        <h2>{{c.outputHeading}}</h2>
        <p class="sub-heading">
          {{c.outputSubHeading}}
        </p>
      </header>

      <div class="answers">
        <div class="ans-container">
          <h3>{{c.ans0}}
            <button class="info-heading"
              @click="openPopup($parent.finTools[0],'finTools')">?</button>
          </h3>
          <div v-if="accumNone.accumulated" class="result">
            <p class="value">
              {{ Math.floor(this.accumNone.months/12) === 0 ?
                '' :Math.floor(this.accumNone.months/12) }} 
              <span>{{  Math.floor(this.accumNone.months/12) === 0 ? 
                '' :yearName(Math.floor(this.accumNone.months/12)) + 
                (Math.floor(this.accumNone.months/12) !== 0 &&
                this.accumNone.months%12 !== 0 ? ' и': '') }} </span>
              {{ this.accumNone.months%12 === 0? '':this.accumNone.months%12 }} 
              <span>
                {{ this.accumNone.months%12 === 0? 
                '' : monthName((this.accumNone.months%12).toString()) }}
              </span>
            </p>
          </div>
          <div v-if="accumNone.accumulated" class="date-description">
            {{c.accumulated.beforeTarget}}
            <span>
              {{ selectedCard.name }}
            </span> 
            {{c.accumulated.afterTarget}} 
            <span v-if="accumNone.price">
              {{ formatNumber(accumNone.price>=1000000? 
                ((accumNone.price/1000000).toFixed(4).toString().slice(0, -3)):
                accumNone.price.toString(), true
              ) + (accumNone.price>=1000000? ' млн ₽': ' ₽') }}
            </span>
            {{c.accumulated.afterPrice}}
          </div>

          <div v-if="!accumNone.accumulated" class="result">
            <p class="value"> 
              <span>{{ c.notAccumulated.result }}</span>
            </p>
          </div>
          <div v-if="!accumNone.accumulated" class="date-description">
            {{ c.notAccumulated.text }} 
              <span>{{ c.notAccumulated.advice }}</span>
          </div>
        </div>

        <div class="ans-container">
          <h3>{{c.ans1}}
            <button class="info-heading"
              @click="openPopup($parent.finTools[1],'finTools')">?</button>
          </h3>
          <div v-if="accumBank.accumulated" class="result">
            <p class="value">
              {{ Math.floor(this.accumBank.months/12) === 0 ?
                '' :Math.floor(this.accumBank.months/12) }} 
              <span>{{  Math.floor(this.accumBank.months/12) === 0 ? 
                '' :yearName(Math.floor(this.accumBank.months/12))  + 
                (Math.floor(this.accumBank.months/12) !== 0 &&
                this.accumBank.months%12 !== 0 ? ' и': '') }} </span>
              {{ this.accumBank.months%12 === 0? '':this.accumBank.months%12 }} 
              <span>
                {{ this.accumBank.months%12 === 0? 
                '' : monthName((this.accumBank.months%12).toString()) }}
              </span>
            </p>
          </div>
          <div v-if="accumBank.accumulated" class="date-description">
            {{c.accumulated.beforeTarget}}
            <span>
              {{ selectedCard.name }}
            </span> 
            {{c.accumulated.afterTarget}} 
            <span v-if="accumBank.price">
              {{ formatNumber(accumBank.price>=1000000? 
                ((accumBank.price/1000000).toFixed(4).toString().slice(0, -3)):
                accumBank.price.toString(), true
              ) + (accumBank.price>=1000000? ' млн ₽': ' ₽') }}
            </span>
            {{c.accumulated.afterPrice}}
          </div>
          <div v-if="!accumBank.accumulated" class="result">
            <p class="value"> 
              <span>{{ c.notAccumulated.result }}</span>
            </p>
          </div>

          <div v-if="!accumBank.accumulated" class="date-description">
            {{ c.notAccumulated.text }} 
              <span>{{ c.notAccumulated.advice }}</span>
          </div>
        </div>

        <div class="ans-container">
          <h3>{{c.ans2}}
            <button class="info-heading"
              @click="openPopup($parent.finTools[2],'finTools')">?</button>
          </h3>
          <div v-if="accumInvest.accumulated" class="result">
            <p class="value">
              {{ Math.floor(this.accumInvest.months/12) === 0 ?
                '' :Math.floor(this.accumInvest.months/12) }} 
              <span>{{  Math.floor(this.accumInvest.months/12) === 0 ? 
                '' :yearName(Math.floor(this.accumInvest.months/12)) + 
                (Math.floor(this.accumInvest.months/12) !== 0 &&
                this.accumInvest.months%12 !== 0 ? ' и': '') }} </span>
              {{ this.accumInvest.months%12 === 0? '':this.accumInvest.months%12 }} 
              <span>
                {{ this.accumInvest.months%12 === 0? 
                '' : monthName((this.accumInvest.months%12).toString()) }}
              </span>
            </p>
          </div>
          <div v-if="accumInvest.accumulated" class="date-description">
            {{c.accumulated.beforeTarget}}
            <span>
              {{ selectedCard.name }}
            </span> 
            {{c.accumulated.afterTarget}}  
            <span v-if="accumInvest.price">
              {{ formatNumber(accumInvest.price>=1000000? 
                ((accumInvest.price/1000000).toFixed(4).toString().slice(0, -3)):
                accumInvest.price.toString(), true
              ) + (accumInvest.price>=1000000? ' млн ₽': ' ₽') }}
            </span>
            {{c.accumulated.afterPrice}}
          </div>

          <div v-if="!accumInvest.accumulated" class="result">
            <p class="value"> 
              <span>{{ c.notAccumulated.result }}</span>
            </p>
          </div>
          <div v-if="!accumInvest.accumulated && !accumInvest.preaccumulated" class="date-description">
            {{ c.notAccumulated.text }} 
              <span>
                {{ c.notAccumulated.advice }}
              </span>
          </div>
        </div>
      </div>
      <a href="#top" class="btn">{{c.btnMore}}</a>
    </div>
    <footer>
      <h4>{{ c.footerText.beforeEmail }}
        <a :href="'mailto:'+c.footerText.email">{{ c.footerText.email }}</a>
      </h4>
      <div class="policy">
        <p v-for="(p, i) in settings.policy" :key="i">
          {{ p }}
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import RangeSlider from '@/assets/vue-range-slider'
import '@/assets/vue-range-slider.css'

export default {
  components: {
    RangeSlider,
  },
  data(){return {
    c: this.$parent.content[2],
    settings: this.$parent.content[3],

    startVal: 15000,
    startValInput: 15000,
    money: {
      min: 5000,
      max: 10000000,
      step: 5000,
      minlength: 4,
      maxlength: 8
    },

    additionVal: 15000,
    additionValInput: 15000,
    moneyAdd: {
      min: 0,
      max: 100000,
      step: 500,
      minlength: 1,
      maxlength: 6
    },

    checked: false,
    checkboxes: [false, false],

    cards: this.generateCards(),
    selectedCard: {},
    selectedCardId: 0,

    accumNone: {},
    accumBank: {},
    accumInvest: {},

    animation: false,
  }}, 
  mounted() {
    this.money = {
      min: +this.settings.accumulation.startMoneyInput.min,
      max: +this.settings.accumulation.startMoneyInput.max,
      step: +this.settings.accumulation.startMoneyInput.step,
      minlength: +this.settings.accumulation.startMoneyInput.min.length,
      maxlength: +this.settings.accumulation.startMoneyInput.max.length
    }
    this.moneyAdd = {
      min: +this.settings.accumulation.monthlyAddInput.min,
      max: +this.settings.accumulation.monthlyAddInput.max,
      step: +this.settings.accumulation.monthlyAddInput.step,
      minlength: +this.settings.accumulation.monthlyAddInput.min.length,
      maxlength: +this.settings.accumulation.monthlyAddInput.max.length
    }
    this.startVal = +this.settings.accumulation.startMoneyInput.start
    this.startValInput = +this.settings.accumulation.startMoneyInput.start
    this.additionVal = +this.settings.accumulation.monthlyAddInput.start
    this.additionValInput = +this.settings.accumulation.monthlyAddInput.start

    this.selectedCard = this.cards[this.selectedCardId]
    this.accumNone = this.getMonthsToStockpiling(this.startVal, this.additionVal, this.$parent.finTools[0], this.selectedCard)
    this.accumBank = this.getMonthsToStockpiling(this.startVal, this.additionVal, this.$parent.finTools[1], this.selectedCard)
    this.accumInvest = this.getMonthsToStockpiling(this.startVal, this.additionVal, this.$parent.finTools[2], this.selectedCard)

    this.resize('startVal')
    this.resize('additionVal')
  },
  methods: {
    resize(name) {
      let currency = document.querySelector(`.${name}Cy`)
      let hide = document.querySelector(`.${name}Hide`)
      hide.textContent = this[name+'Input'].toLocaleString('ru') || '0'
      currency.style.transform = `translateX(${+hide.offsetWidth/2 + 10}px)`
    },
    openPopup(content, mode, data) {
      this.$parent.popupContent = content
      this.$parent.popupMode = mode
      if (data && mode === 'index') data = data.find(el => el.unit)
      this.$parent.popupData = data
      this.$parent.popupOpened = false
      setTimeout(() => {
        this.$parent.popupOpened = true
      }, 50);
      setTimeout(() => {
        document.querySelector('.popup img').scrollIntoView({block: "start", behavior: "smooth"})
      }, 500)
    },
    getPriceToDate(months, dimension){
      let price = dimension.startPrice
      for(months; months >0; months--){
        price += price * dimension.coefficient
      }
      return price;
    },
    getMonthsToStockpiling(startMoney, monthlyAdd, financeTool, dimension){
      let demPrice = dimension.startPrice
      let accumAmount = startMoney
      let monthsPassed = 0
      while(true){
        monthsPassed ++
      	accumAmount += accumAmount * financeTool.coefficient
        accumAmount += monthlyAdd
      	demPrice += demPrice * dimension.coefficient 
        if(accumAmount >= demPrice) {
          return {
            accumulated: true,
            price: Math.round(demPrice), 
            months: monthsPassed,
          }
        }
        if(monthsPassed >= 420) {
          return {
            accumulated: false,
            price: Math.round(demPrice), 
            months: monthsPassed,
          }
        }	
      }
      return
    },
    generateCards() {
      let data = this.$parent.subjStockpiling
      let arr = []
      for (let i = 0; i<data.length; i++) {
        arr.push(data[0].devices[i], data[1].cars[i], data[2].real_estate[i])
      }
      return arr
    },
    cardsClickHandler(e) {
      let t = e.target
      if (!t.closest('.card')) return;
      let id = t.closest('.card').dataset.id
      this.selectedCard = this.cards[id]
      this.selectedCardId = +id

      if (this.startVal >= this.selectedCard.startPrice) {
        this.startVal = Math.round(this.selectedCard.startPrice-this.money.min)
      }
    },
    optionsClickHandler(e) {
      let t = e.target
      if (!t.closest('.option')) return;
      if (!t.dataset.val) return
      else {
        let val = t.dataset.val
        let id = +e.target.id.slice(2)
        this.checkboxes[id] = !this.checkboxes[id]
        if (!e.target.checked) {
          this.additionVal = this.additionValInput =
          +this.additionVal - +val
          let check = false
          this.checkboxes.forEach(el => el===true? check = true: '')
          this.checked = check
        } else {
          this.additionVal = this.additionValInput =
          +this.additionVal + +val
          this.checked = true
        }
      }
      
    },
    yearName(year) {
    let txt;
    let count = year % 100;
    if (count >= 5 && count <= 20) txt = 'лет'
    else {
      count = count % 10
      if (count == 1) txt = 'год'
      else if (count >= 2 && count <= 4)  txt = 'года'
      else txt = 'лет'
    }
    return " "+txt
    },
    monthName(month) {
    let txt;
    let count = month % 100;
    if (count >= 5 && count <= 20) txt = 'месяцев'
    else {
      count = count % 10
      if (count == 1) txt = 'месяц'
      else if (count >= 2 && count <= 4)  txt = 'месяца'
      else txt = 'лет'
    }
    return " "+txt
    },
    changeView(valOld, valNew) {
      if (isNaN(this[valNew])) {
        this[valNew] = 5000
      }
      this[valOld] = this[valNew]
    },
    onSliderFocus(name) {
      document.querySelector(`.${name}Input`).blur()
    },
    blurHandler(e, name) {
      if (e) e.target.setAttribute('type', 'text')
      this[name + 'Input'] = this[name + 'Input'].toLocaleString('ru') || 0
    },
    focusHandler(e, name) {
      this[name + 'Input'] = +this[name + 'Input'].toString().split(' ').join('')
      e.target.setAttribute('type', 'number')
    },
    handleInput(e, valOld, valNew, { maxlength, minlength, max, min }) {
      this.resize(valOld)
      this[valNew] = +e.target.value
      if (!+this[valNew]) this[valNew] = 0
      if (+this[valNew] === 0) return
      this[valNew] = +e.target.value.split('.').join('').split(',').join('')
      e.target.value = +this[valNew]

      if (e.target.value.length >= minlength && +e.target.value>= +min) {
        if (e.target.value.length > maxlength || +e.target.value> +max ) {
          this[valNew] = Math.floor((+e.target.value)/10)
          this[valOld] = Math.floor((+e.target.value)/10)
          this.resize(valOld)
        } 
        else this[valOld] = +e.target.value
      }
    },
    handleInputChange(valOld, valNew, { min, max, minlength, maxlength },isRange) {
      if (isRange) {
        max = this.selectedCard.startPrice
        if (this[valOld].length > +maxlength || 
          +this[valOld] > +max) {
            max = Math.round(this.selectedCard.startPrice-min)
            this[valNew] = +max
            this[valOld] = +max
          }
        else if (this[valOld].length < +minlength || 
          +this[valOld] < +min) {
            this[valOld] = +min
            this[valOld] = +min
          }
        else {
          this[valNew] = this[valOld].toLocaleString('ru')
        }
      } else {
        if (valOld ==='startVal') max = this.selectedCard.startPrice
        if (this[valNew].length > +maxlength || 
          +this[valNew] > +max) {
            if (valOld ==='startVal') max = Math.round(this.selectedCard.startPrice-min)
            this[valNew] = +max
            this[valOld] = +max
          }
        else if (this[valNew].length < +minlength || 
          +this[valNew] < +min) {
            this[valNew] = +min
            this[valOld] = +min
          }
        else this[valOld] = +this[valNew]
      }
      this.resize(valOld)
    },
    formatNumber(val, ceil) {
      let str = ceil? val
        :val.split('.').join('').split(',').join('')
      str = (+str).toLocaleString('ru')
      return str || 0
    },
    btnAnimation() {
      let el = document.querySelector('.gradient-btn-accum')
      if (this.animation) return
      let animation = el.animate([
        {transform: 'translate(0)'},
        {transform: 'translate(0, -5px)'},
      ], 100)
      this.animation = true
      animation.addEventListener('finish', e => {
        let animation = el.animate([
          {transform: 'translate(0, -5px)'},
          {transform: 'translate(0)'},
        ], 100)
        setTimeout(() => {
          this.animation = false
        }, 200)
      })
    },
    openPopup(content, mode, data) {
      this.$parent.popupContent = content
      this.$parent.popupMode = mode
      if (data && mode === 'index') data = data.find(el => el.unit)
      this.$parent.popupData = data
      this.$parent.popupOpened = false
      setTimeout(() => {
        this.$parent.popupOpened = true
      }, 50);
      setTimeout(() => {
        document.querySelector('.popup img').scrollIntoView({block: "start", behavior: "smooth"})
      }, 500)
    },
  },
  watch: {
    selectedCard() {
      this.money.max = this.selectedCard.startPrice
      if (this.selectedCard.startPrice < 100000) this.money.step = 1000
      else this.money.step = 5000
    },
    startVal() {
      this.changeView('startValInput', 'startVal')
      this.accumNone = this.getMonthsToStockpiling(this.startVal, this.additionVal, this.$parent.finTools[0], this.selectedCard)
      this.accumBank = this.getMonthsToStockpiling(this.startVal, this.additionVal, this.$parent.finTools[1], this.selectedCard)
      this.accumInvest = this.getMonthsToStockpiling(this.startVal, this.additionVal, this.$parent.finTools[2], this.selectedCard)
      this.btnAnimation()
      
      this.resize('startVal')
      if (!document.activeElement.classList.contains('startValInput')) {
        document.querySelector('.startValInput').setAttribute('type', 'text')
        this.startValInput= this.startVal.toLocaleString('ru')
      }
    },
    startValInput() {
      this.resize('startVal')
    },
    additionVal() {
      this.changeView('additionValInput', 'additionVal')
      this.accumNone = this.getMonthsToStockpiling(this.startVal, this.additionVal, this.$parent.finTools[0], this.selectedCard)
      this.accumBank = this.getMonthsToStockpiling(this.startVal, this.additionVal, this.$parent.finTools[1], this.selectedCard)
      this.accumInvest = this.getMonthsToStockpiling(this.startVal, this.additionVal, this.$parent.finTools[2], this.selectedCard)
      this.btnAnimation()

      this.resize('additionVal')
      if (!document.activeElement.classList.contains('additionValInput')) {
        document.querySelector('.additionValInput').setAttribute('type', 'text')
        this.additionValInput= this.additionVal.toLocaleString('ru')
      }
    },
    selectedCardId() {
      this.accumNone = this.getMonthsToStockpiling(this.startVal, this.additionVal, this.$parent.finTools[0], this.selectedCard)
      this.accumBank = this.getMonthsToStockpiling(this.startVal, this.additionVal, this.$parent.finTools[1], this.selectedCard)
      this.accumInvest = this.getMonthsToStockpiling(this.startVal, this.additionVal, this.$parent.finTools[2], this.selectedCard)
      this.btnAnimation()
    }
},
}
</script>

<style lang="scss" scoped>
@import '@/assets/main.scss';

.blur {
  transition: 0.3s;
  filter: blur(10px);
}

#app .input-label {
  margin: 15px 0 0;
  padding: 18px 0;
  min-height: 65px;
  .input-val {
    max-height: 40px;
    line-height: 40px;
    position: relative;
    text-align: center;
    width: 100%;
    margin: 0;
    padding: 0;
    color: $pop_sum;
    &:disabled {
      opacity: 0.7;
    }
  }

.disabled {
  opacity: 0.7;
}

  .currency {
    position: absolute;
    transition: 0.1s ease;
    transform: translateX(65px);
  }
  .input-buffer{
    font-family: 'Rubik', sans-serif;
    font-weight: 500;
    font-size: 40px;
    position: absolute;
    top: -10000px;
    left: -10000px;
    visibility: hidden;
    white-space: nowrap;
  }
}

.Forecast .accumulation,
.Home .accumulation {
  width: 0;
  height: 90vh;
  overflow: hidden;
  transform: translate(425px, 0);
  opacity: 0;
  padding: 0;
  margin: 0;
}

.Accumulation .accumulation {
  transform: translate(-50%, 0);
  opacity: 1;

  height: auto;
  top: 52px;
  overflow: hidden;
  overflow-y: visible;
}
.accumulation {
  position: absolute;
  width: 100%;
  max-width: 425px;
  transform: translate(100%, 0);
  left: 50%;
  top: 52px;
  height: 100%;
  transition: 0.5s ease;
  opacity: 0;
  .btn {
    background: $btn_grad_2;
    transition: 0.5s ease;
  }
  .enter {
    padding: 20px;
    .grid {
      .info {
        color: $pop_sum;
      }
      .card button {
        transition: 0.3s;
        background: $anctive;
      }
      .card.selected button {
        background: $pop_sum;
      }
    }
    .input-label,
    .sub-span {
      color: $pop_sum;
    }
    .input:focus ~ label .labelInner::after {
      background: $pop_sum;
      animation: blink-caret2 2s step-end infinite;
    }
    .options {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      margin-top: 15px;
      .option {
        margin: 0 0 5px;
        label {
          display: inline-block;
          margin: 0;
          width: fit-content;
          font-family: 'Rubik', sans-serif;
          font-weight: 500;
          font-size: 14px;
          line-height: 17px;
          min-height: 30px;
          text-align: center;
          color: $pop_sum;
          border: 1px solid $pop_sum;
          border-radius: 15px;
          transition: 0.3s ease;
          padding: 7px 15px 6px;
        }
        input {
          width: 0px;
          height: 0px;
          padding: 0;
          position: absolute;
          opacity: 0;
          outline: none;
          &:checked ~ label {
            background: $pop_sum;
            color: $white;
          }
        }
      }
    }
  }
  .output {
    header {
      padding: 20px;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0) 100%);
      border-radius: 15px 15px 5px 5px;
      h2 {
        font-family: 'Rubik', sans-serif;
        font-weight: bold;
        font-size: 28px;
        line-height: 33px;
      }
      .sub-heading {
        font-family: 'Rubik', sans-serif;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
      }
    }
  }
}


.accumulation {
  max-width: 425px;
  .answers {
    margin-bottom: 10px;
    .ans-container {
      padding: 10px 20px 20px;
      margin-bottom: 0px;
      h3 {
        font-family: 'Rubik', sans-serif;
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        display: flex;
        align-items: center;
      }
      .info-heading {
        background: rgba(244, 246, 255, 0.5);;
        padding: 0;
        margin-bottom: -2px;
        margin-left: 5px;
        display: block;
        border: none;
        border-radius: 50%;
        width: 16px;
        height: 16px;
        font-family: 'Rubik', sans-serif;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        color: $pop_sum;
      }
      .result {
        padding-top: 15px;
        margin: 15px 0;
        height: 60px;
        overflow: visible;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0) 100%);
        border-radius: 15px 15px 0px 0px;
        .value {
          color: $pop_sum;
          font-family: 'Rubik', sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 40px;
          line-height: 47px;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          margin-bottom: 10px;
          span {
            display: block;
            margin: 0 10px 5px;
            font-size: 20px;
            line-height: 23px;
          }
        }
      }
    }
    .date-description {
      margin-top: 5px;
      font-family: 'Rubik', sans-serif;
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
      span {
        color: $pop_sum;
      }
    }
  }
  footer {
    margin-top: 50px;
  }
}
</style>